import { useState, useEffect } from 'react';

import { debounce } from '../../../utils/debounce';

const DEFAULT_KEYBOARD_HEIGHT = 320; // Approximate keyboard height for mobile devices
const OPERATORS_EXTRA_SPACE = 60; // Space adjustment for operator alignment (iframes)

export const useMaxKeyboardAwareDrawerHeight = (): number | null => {
  const [maxHeight, setMaxHeight] = useState<number | null>(null);

  useEffect(() => {
    const handleFocusIn = debounce((event: FocusEvent): void => {
      if (window.matchMedia('(orientation: portrait)').matches) {
        const target = event.target as HTMLInputElement | HTMLTextAreaElement | undefined;
        if (target && ['text', 'textarea'].includes(target.type)) {
          let roughKeyboardHeight = DEFAULT_KEYBOARD_HEIGHT;
          if (window.top === window.self) {
            roughKeyboardHeight = window.visualViewport?.height || window.innerHeight || 360;
          }
          setMaxHeight(roughKeyboardHeight - OPERATORS_EXTRA_SPACE);
        }
      }
    }, 300);

    const handleFocusOut = debounce((): void => {
      setMaxHeight(null);
    }, 200);

    window.addEventListener('focusin', handleFocusIn);
    window.addEventListener('focusout', handleFocusOut);

    return (): void => {
      window.removeEventListener('focusin', handleFocusIn);
      window.removeEventListener('focusout', handleFocusOut);
    };
  }, []);

  return maxHeight;
};
